import React from 'react';
import IntegrationBlock from '../../index';
import StatusBlock from '../StatusBlock';
import TechData from '../TechData';
import IntervalInfo from '../IntervalInfo';

const DeliveryInterval = (props) => {
  const { data, modalType, isChangeable } = props;

  return (
    <>
      {data !== undefined && data !== null && (
        <>
          <IntegrationBlock
            title="Интервал поставки"
            isChangable={isChangeable}
            modalType={modalType}
            modalData={data}
            isSaveable={
              data?.supplyData?.draftId !== undefined &&
              data?.supplyData?.draftId !== null &&
              data?.supplyData?.draftId !== 0 &&
              (data?.supplyData?.supplyId === undefined ||
                (data?.supplyData?.supplyId === null && data?.supplyData?.supplyId === 0))
            }
          />
          <IntervalInfo
            fromInTimezone={data.supplyData?.fromInTimezone}
            toInTimezone={data.supplyData?.toInTimezone}
            timeslot={data.supplyData?.timeSlotInfo?.timeslot}
          />
          <StatusBlock
            status={data.techData?.supplyTimeslotsTechData?.status}
            syncro={data.techData?.supplyTimeslotsTechData?.supplyTimeslotSynchronized}
            draftErrors={data.techData?.supplyTimeslotsTechData?.supplyTimeslotErrors}
          />
          <TechData
            code={data.techData?.supplyTimeslotsTechData?.supplyTimeslotOperationId}
            date={data.techData?.supplyTimeslotsTechData?.supplyTimeslotRequestTs}
            ozonDate={data.techData?.supplyTimeslotsTechData?.supplyTimeslotSyncResultTs}
          />
        </>
      )}
    </>
  );
};

export default DeliveryInterval;
